import React, { useState, useEffect } from 'react';
import './ResumeManager.css';

const ResumeManager = ({ resumes, activeId, onSwitch, onNew, onDelete, onRename, onClose }) => {
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  useEffect(() => {
    const handleKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const handleStartRename = (resume) => {
    setEditingId(resume.id);
    setEditName(resume.name);
  };

  const handleFinishRename = () => {
    if (editingId && editName.trim()) {
      onRename(editingId, editName.trim());
    }
    setEditingId(null);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="resume-manager" onClick={(e) => e.stopPropagation()}>
        <div className="manager-header">
          <h2>Your Resumes</h2>
          <button className="manager-close" onClick={onClose}>×</button>
        </div>

        <div className="manager-body">
          {resumes.length === 0 ? (
            <div className="manager-empty">No resumes yet. Create one!</div>
          ) : (
            <div className="resume-list">
              {resumes.map(resume => (
                <div
                  key={resume.id}
                  className={`resume-list-item ${resume.id === activeId ? 'active' : ''}`}
                >
                  <div className="resume-list-content" onClick={() => onSwitch(resume.id)}>
                    <span className="resume-list-icon">📄</span>
                    <div className="resume-list-info">
                      {editingId === resume.id ? (
                        <input
                          className="rename-input"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value)}
                          onBlur={handleFinishRename}
                          onKeyDown={(e) => e.key === 'Enter' && handleFinishRename()}
                          autoFocus
                          onClick={(e) => e.stopPropagation()}
                        />
                      ) : (
                        <span className="resume-list-name">{resume.name}</span>
                      )}
                      <span className="resume-list-meta">
                        {resume.data?.personalInfo?.fullName || 'No name set'}
                      </span>
                    </div>
                  </div>
                  <div className="resume-list-actions">
                    <button className="resume-action-btn" title="Rename"
                      onClick={(e) => { e.stopPropagation(); handleStartRename(resume); }}>
                      ✎
                    </button>
                    <button className="resume-action-btn danger" title="Delete"
                      onClick={(e) => { e.stopPropagation(); onDelete(resume.id); }}>
                      ✕
                    </button>
                  </div>
                  {resume.id === activeId && <span className="active-badge">Active</span>}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="manager-footer">
          <button className="manager-new-btn" onClick={() => { onNew(); onClose(); }}>
            + Create New Resume
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeManager;
